import { configureStore } from '@reduxjs/toolkit';
import {
  loggedInFormDataReducer as loggedInFormData,
  loggedInFormInputReducer as formInputSelection,
  loggedInFormValidReducer as loggedInFormValid,
  n2nDeferredPasswordFieldProgressReducer as n2nDeferredPasswordProgress,
  n2nDeferredPasswordFieldValidationReducer as n2nDeferredPasswordFieldValidation,
  n2nFieldProgressReducer as n2nFieldProgress,
  n2nFieldValidationReducer as n2nFieldValidation,
  sharedFormDataReducer as sharedFormData
} from './ducks-devops';
import { deferredSiteNameReducer as deferredSiteName } from './ducks-experimentation';
import { reducerFeatureFlags, reducerProductKeys } from './slice';

const store = configureStore({
  reducer: {
    // ------ Global Redux Slices --
    featureFlags: reducerFeatureFlags,
    productKeys: reducerProductKeys,
    // ------ Devops ducks ------
    n2nFieldProgress,
    n2nFieldValidation,
    n2nDeferredPasswordFieldValidation,
    n2nDeferredPasswordProgress,
    loggedInFormValid,
    loggedInFormData,
    sharedFormData,
    formInputSelection,
    // ------ Experimentation ducks ------
    deferredSiteName
  },
  devTools: {
    name: '@atlassiansox/bxpkit-wac-sign-up/global'
  }
});

// Infer the `RootState` and `AppDispatch` types from the store itself
export type RootState = ReturnType<typeof store.getState>;
// Inferred type: {posts: PostsState, comments: CommentsState, users: UsersState}
export type AppDispatch = typeof store.dispatch;

export default store;
